import React, { useCallback } from "react";
import { ViewType } from "../../../../enums";
import { NoResults, ListViewBase, ListViewWithInMemorySorting } from "../../../../components";
import ManagedByContactRow from "./ManagedByContactRow";
import columnOptions from "./columnOptions";
import type NewContact from "../../../../interfaces/NewContact";

export interface ManagedByContactListProps {
  contacts: NewContact[];
  onContactRemoved: (contactId: number) => void;
  accountId: number;
  moboAccountId: number;
}

const mapColumnName = (columnName: string) => {
  switch (columnName.toLowerCase()) {
    case columnOptions[2].name.toLowerCase():
      return "title";
    case columnOptions[0].name.toLowerCase():
      return "firstName";
    default:
      return columnName;
  }
};

const ManagedByContactList = ({ contacts, onContactRemoved, accountId, moboAccountId }: ManagedByContactListProps) => {
  const renderNoResults = () => (
    <NoResults
      title="No Contacts"
      description={
        <div className="text-muted">
          <i>Use the form above to add contacts for this account</i>
        </div>
      }
      iconClassName="fal fa-user"
    />
  );

  const buildTableBody = useCallback(
    (contact: NewContact) => (
      <ManagedByContactRow
        contact={contact}
        isReadOnly={false}
        onContactRemoved={onContactRemoved}
        accountId={accountId}
        moboAccountId={moboAccountId}
      />
    ),
    [onContactRemoved, moboAccountId, accountId],
  );

  return (
    <ListViewWithInMemorySorting
      as={ListViewBase}
      viewType={ViewType.LIST}
      columnOptions={columnOptions}
      mapColumnName={mapColumnName}
      items={contacts}
      withFooter={false}
      withSelection={false}
      noResultsContent={renderNoResults()}
      buildTableBody={buildTableBody}
    />
  );
};

export default ManagedByContactList;
